<template>
  <form-group>
    <validation-provider v-slot="{errors}" rules="required">
      <icu-select
        :errors="[...errors, ...getFieldErrors('type')]"
        :value="stepFormData.type"
        :options="employmentOptions"
        :label="$t('application-form.step-0.employees')"
        placeholder=""
        required
        @input="emitInput('type', $event)"
      />
    </validation-provider>
    <validation-provider v-slot="{errors}" rules="required">
      <icu-select
        :errors="[...errors, ...getFieldErrors('income_level')]"
        :value="stepFormData.income_level"
        :options="proceedOptions"
        :label="$t('application-form.step-0.proceeds')"
        placeholder=""
        required
        @input="emitInput('income_level', $event)"
      />
    </validation-provider>
  </form-group>
</template>

<script>
import FormWrapper from '@/components/views/RegisterPage/FormWrapper.vue'
import FormGroup from '@/components/views/RegisterPage/FormGroup.vue'
import { ValidationProvider } from 'vee-validate'
import IcuSelect from '@/components/inputs/IcuSelect.vue'
import { api } from '@/api/api'
import { cloneDeep } from 'lodash'

export default {
  name: 'EmploymentStep',
  components:{
    FormWrapper,
    FormGroup,
    ValidationProvider,
    IcuSelect
  },
  props: {
    stepFormData: {
      type: Object,
      required: true
    },
    backendErrors: {
      type: Object,
      default: () => {}
    },
  },

  data() {
    return {
      employmentOptions: [],
      proceedOptions: [],
    }
  },

  async beforeMount() {
    try {
      const employmentRes = await api.profile.getEmploymentOptions()
      const proceedRes = await api.profile.getProceedOptions()
      this.employmentOptions = employmentRes.data
      this.proceedOptions = proceedRes.data
      if(!this.stepFormData.income_level) {
        await this.emitInput('income_level', this.proceedOptions[0].id )
      }
      if(!this.stepFormData.type) {
        await this.emitInput('type', this.employmentOptions[0].id )
      }

    } catch(err) {
      console.log(err)
    }
  },

  methods: {
    getFieldErrors(fieldName) {
      if (this.backendErrors) {
        return this.backendErrors[fieldName] ?? []
      }
      return []

    },

    async emitInput(formKey, value) {
      const data = cloneDeep(this.stepFormData)
      data[formKey] = value
      await this.$emit('update-field', {formKey: 'employment', value: data})
    },
  }
}
</script>

<style scoped>

</style>
